export const config = {
  relay: 'https://api.nos.dev/api/v2'
}